/**
 * Format date for display
 */
export const formatDate = (dateValue: string | null | undefined): string => {
  if (!dateValue) return '';
  return new Date(dateValue).toLocaleDateString();
};
